import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(React.createElement(App, null ), document.getElementById('root'));
